module.exports = __webpack_public_path__ + "img/06.abe02fa6.jpg";